var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowCoach(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 55,
    zoomAndPan: "magnify",
    viewBox: "0 0 41.25 41.250001",
    height: 55,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%",
    id: "d4d3de6151"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0",
    colorInterpolationFilters: "sRGB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: 7438719575
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 13.53125 12.742188 L 36.367188 12.742188 L 36.367188 22.320312 L 13.53125 22.320312 Z M 13.53125 12.742188 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "7e628190d0"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#d4d3de6151)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.125,
    width: 49.5,
    fill: "#000000",
    y: -4.125,
    height: 49.500001,
    fillOpacity: 0.498
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "0581bc413e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.816406 0.238281 L 23.648438 0.238281 L 23.648438 9.8125 L 0.816406 9.8125 Z M 0.816406 0.238281 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "2e65378bbe"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 24,
    y: 0,
    height: 10
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7438719575)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffde59",
    d: "M 36.363281 17.53125 L 31.558594 12.742188 L 31.558594 16.335938 L 13.535156 16.335938 L 13.535156 18.726562 L 31.558594 18.726562 L 31.558594 22.320312 Z M 36.363281 17.53125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#7e628190d0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 4, 21)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2e65378bbe)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0581bc413e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffde59",
    d: "M 0.820312 5.023438 L 5.625 0.238281 L 5.625 3.828125 L 23.644531 3.828125 L 23.644531 6.222656 L 5.625 6.222656 L 5.625 9.8125 Z M 0.820312 5.023438 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowCoach);
export default __webpack_public_path__ + "static/media/arrow-coach.b41a70a49fe5a888ce8e1dee08c94de6.svg";
export { ForwardRef as ReactComponent };